import { useDebounce } from '../../../../../../../shared/libs/useDebounce';
import { ITag } from '../../../../../../../entities/module/private-template-module-tag/api/types';
import { SearchTagGroupsBar } from './search-bar/SearchTagGroupsBar';
import { privateTemplateModuleTagAPI } from '../../../../../../../entities/module/private-template-module-tag/api/api';

interface GroupTagsSearchBarProps {
    search: string,
    setSearch: (search: string) => void,
	createTag: (name: string) => Promise<void>,
}

export const GroupTagsSearchBar = ({
	search,
	setSearch,
	createTag,
}: GroupTagsSearchBarProps) => {
	const debounceSearch = useDebounce(search.trim(), 200);

	const { data } = privateTemplateModuleTagAPI.useGetAllQuery({
		page: 1,
		limit: 127,
		search: debounceSearch,
	});

	return (
		<SearchTagGroupsBar
			search={search}
			setSearch={setSearch}
			createTag={createTag}
			tags={(data?.moduleTags || []) as ITag[]}
		/>
	);
};
